import { render, staticRenderFns } from "./menuSearch.vue?vue&type=template&id=04a69fe6"
import script from "./menuSearch.vue?vue&type=script&lang=ts"
export * from "./menuSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports